import React from 'react'
import {PureRenderMixin} from 'pure-render-mixin'
import createReactClass from 'create-react-class'

var ProductItemInformation = createReactClass({

	mixins: [PureRenderMixin], //Don't use PureRenderMixin unless you know what you're doing
	render: function() {
		var lowRes, autoCrop;

		if(this.props.showLowResWarning) {
			lowRes = <li className="ope-product-list__information__item">
						<span className="ope-product-list__information__icon--lowres ope-icon ope-icon--lowres"></span>
						<span className="ope-product-list__information__item__label">{_("Low resolution image")}</span>
					</li>;
		}
		if(this.props.showAutoCropWarning) {
			autoCrop = <li className="ope-product-list__information__item">
						<span className="ope-product-list__information__icon--crop ope-icon ope-icon--crop"></span>
						<span className="ope-product-list__information__item__label">{_("Photo cropped")}</span>
					</li>;
		}
		return (
			<div className={this.props.className} id={this.props.id}>
				<ul>
					{ autoCrop }
					{ lowRes }
				</ul>
			</div>
		);
	}
});

export default ProductItemInformation;
